import styled, { keyframes } from 'styled-components'

import Icon from '../../Icon'

export const AutocompleteUniselectionContainer = styled.div`
  position: relative;
`

export const IconButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: 4px;
  padding: 0;
  color: #45586b;

  &:disabled {
    cursor: not-allowed;
  }

  * + & {
    margin-left: 4px;
  }
`

IconButton.defaultProps = { type: 'button' }

export const ArrowButton = styled(IconButton)<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
`

const rotate = keyframes`
  from {
    transform: rotate(0)
  }

  to {
    transform: rotate(360deg)
  }
`

export const SpinningIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.status.processing};

  animation: ${rotate} ease-in-out 1s infinite;
`
